
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcFilter as ObcFilterElement} from '@oicl/openbridge-webcomponents/dist/automation/filter/filter.js';
 
 
 

 
 export const ObcFilter = createComponent({
   react: React,
   tagName: 'obc-filter',
   elementClass: ObcFilterElement,
   events: {
     
   }
  });
 
 